'use client';

import { ThemeProvider as Provider } from 'next-themes';

import { useContextData } from '@common/useContextData';

import { isDarkModeEnabled, isSystemDarkModeEnabled, useThemeProviderConfig } from './ThemeProvider.config';

interface Props {
    children: React.ReactNode;
}

export const ThemeProvider = ({ children }: Props) => {
    const themeConfig = useThemeProviderConfig();
    const contextData = useContextData();

    const nextEnv = contextData.env.APP_ENV;
    const darkModeEnabled = isDarkModeEnabled(themeConfig, nextEnv);
    const systemDarkMode = isSystemDarkModeEnabled(themeConfig);

    return (
        <Provider attribute="class" enableColorScheme={darkModeEnabled} enableSystem={systemDarkMode}>
            {children}
        </Provider>
    );
};
